import { apiClient } from "../../lib/http/apiClient";
import type { WebinarCardsListResponse, WebinarCreatePayload, WebinarResponse } from "./types";

export const webinarsService = {
  async createWebinar(payload: WebinarCreatePayload): Promise<WebinarResponse> {
    const { data } = await apiClient.post<WebinarResponse>("/api/webinars", payload);
    return data;
  },

  async uploadWebinarFile(
    webinarId: string,
    file: File,
    fileType: "thumbnail" | "recording",
  ): Promise<{ url: string; file_type: string }> {
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await apiClient.post<{ url: string; file_type: string }>(
      `/api/webinars/${webinarId}/upload`,
      formData,
      {
        params: { file_type: fileType },
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return data;
  },

  async listWebinarCards(skip = 0, limit = 100, topic?: string, status?: string): Promise<WebinarCardsListResponse> {
    const { data } = await apiClient.get<WebinarCardsListResponse>("/api/webinars", {
      params: { skip, limit, ...(topic ? { topic } : {}), ...(status ? { status } : {}) },
    });
    return data;
  },

  async listMyWebinars(skip = 0, limit = 100): Promise<WebinarCardsListResponse> {
    const { data } = await apiClient.get<WebinarCardsListResponse>("/api/webinars/my/webinar", {
      params: { skip, limit },
    });
    return data;
  },

  async getWebinar(webinarId: string): Promise<WebinarResponse> {
    const { data } = await apiClient.get<WebinarResponse>(`/api/webinars/${webinarId}`);
    return data;
  },
};
